import {
  deleteAdminV1StoresStoreIdNotificationTemplatesEvent,
  getAdminV1StoresStoreIdNotificationTemplates,
  postAdminV1StoresStoreIdNotificationTemplatesEventPreview,
  putAdminV1StoresStoreIdNotificationTemplatesEvent,
  type NotificationEvent,
  type NotificationPreview,
  type NotificationTemplate,
  type PostAdminV1StoresStoreIdNotificationTemplatesEventPreviewBody,
  type PutAdminV1StoresStoreIdNotificationTemplatesEventBody,
} from '@nucleus-commerce/api-client/admin';

/** Shopper emails of one store: a bounded list, one entry per event. */
export const notificationsApi = {
  list: (storeId: string): Promise<NotificationTemplate[]> =>
    getAdminV1StoresStoreIdNotificationTemplates({ storeId }).then((r) => r.items),
  save: (
    storeId: string,
    event: NotificationEvent,
    body: PutAdminV1StoresStoreIdNotificationTemplatesEventBody,
  ): Promise<NotificationTemplate> =>
    putAdminV1StoresStoreIdNotificationTemplatesEvent({ storeId, event }, body),
  reset: (storeId: string, event: NotificationEvent): Promise<void> =>
    deleteAdminV1StoresStoreIdNotificationTemplatesEvent({ storeId, event }),
  preview: (
    storeId: string,
    event: NotificationEvent,
    body: PostAdminV1StoresStoreIdNotificationTemplatesEventPreviewBody,
  ): Promise<NotificationPreview> =>
    postAdminV1StoresStoreIdNotificationTemplatesEventPreview({ storeId, event }, body),
};
